module.exports = __webpack_public_path__ + "img/3-1.3896c1b3.png";